import { RegistrationStepProps } from '../RegistrationStep.types';
import { ComponentType } from 'react';
import SummaryStep from './SummaryStep/SummaryStep';
import IntroStep from './IntroStep';

const customStepComponents: Record<
  string,
  ComponentType<RegistrationStepProps>
> = {
  intro: IntroStep,
  summary: SummaryStep,
};

export default customStepComponents;
